//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 是否是H5渠道
let h5 = false

export default {
  name: 'm-buy',
  props: [
    'measureState'
  ],
  data () {
    return {
      h5: h5
    }
  },
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
  },
  computed: {
    tel () {
      if (this.h5 && !this.$store.state.h5.configuration.isNull && this.$store.state.h5.configuration.serviceTel !== '') return 'tel:' + this.$store.state.h5.configuration.serviceTel
      return 'tel:400-661-2992'
    },
    number () {
      if (!this.measureState) {
        return '105'
      } else if (this.measureState) {
        if (this.$store.getters.computMeasurePayment === null) {
          return '105'
        }
        return this.$store.getters.computMeasurePayment
      }
    },
    measureReady () {
      return this.$store.state.order.measureReady
    },
    showPoster () {
      /**
       * 判断是否显示海报
       */
      // 是否是分享过的
      const isShare = this.$route.query.isShare
      // 是否是悟空保的innerCode
      const isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) !== -1
      if ((isShare === 'true') || isWKB || this.h5) return false
      return true
    },
    posterURL () {
      return window.location.protocol + '//' + window.location.hostname + '/illness/sharePoster?productCode=' + this.$store.state.order.productId + '&innerCode=' + this.$store.state.order.userId
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Buy.vue